import { Status } from '@eigtech/invoicing-types'
import { CustomThemeTypings } from '@eigtech/ui-shared-dave'
import { exhaustive } from 'exhaustive'

export const getBillStatusColor = (status: Status) =>
  exhaustive(status, {
    created: (): CustomThemeTypings['colorSchemes'] => 'blue',
    deleted: (): CustomThemeTypings['colorSchemes'] => 'yellow',
    pending: (): CustomThemeTypings['colorSchemes'] => 'indigo',
    paymentMade: (): CustomThemeTypings['colorSchemes'] => 'green',
    sent: (): CustomThemeTypings['colorSchemes'] => 'purple',
  })
